import { ListReportGroupAssetsParams } from '@/api/generatedApi';
import { DATA_GRID_LAZY_PAGE_SIZE } from '@/components/DataGrid/definitions';
import { api } from '@/services/api';
import { useTenants } from '@/services/tenants/useTenants';
import { useDataGridFetcher } from '../useDataGridFetcher';

export const REPORT_GROUP_ASSETS_QUERY_KEY = 'reports.listReportGroupAssets';

export const getReportGroupAssetsQueryKey = ({
  reportId,
  groupId,
  page,
  perPage,
  tenantId,
}: {
  reportId?: string;
  groupId?: string;
  page?: string | number;
  perPage?: string | number;
  tenantId?: string;
} = {}) => [
  REPORT_GROUP_ASSETS_QUERY_KEY,
  {
    reportId,
    groupId,
    page: +(page ?? 1),
    perPage: +(perPage ?? DATA_GRID_LAZY_PAGE_SIZE),
    tenantId,
  },
];

const queryFunction =
  ({
    reportId,
    groupId,
    page,
    perPage,
    tenantId,
  }: {
    reportId?: string;
    groupId?: string;
    page?: string | number;
    perPage?: string | number;
    tenantId?: string;
  } = {}) =>
  () => {
    const parameters: ListReportGroupAssetsParams = {
      tenantId: tenantId ?? '',
      reportId: reportId ?? '',
      groupId: groupId ?? '',
      page: +(page ?? 1),
      perPage: +(perPage ?? DATA_GRID_LAZY_PAGE_SIZE),
    };

    return api.reports.listReportGroupAssets(parameters);
  };

export const useListReportGroupAssets = ({ reportId, groupId }: { reportId?: string; groupId?: string }) => {
  const { getTenantId } = useTenants();
  return useDataGridFetcher({
    queryKey: parameters => getReportGroupAssetsQueryKey({ tenantId: getTenantId(), reportId, groupId, ...parameters }),
    queryFn: parameters => queryFunction({ tenantId: getTenantId(), reportId, groupId, ...parameters }),
    transformResponse: data => ({
      contents: data.assets.map(asset => ({ ...asset, contentType: 'asset' as const })),
      pageData: data.pageData,
    }),
    enabled: !!reportId && !!groupId,
  });
};
